import React, { useState } from "react";
import styles from "./Permission.module.css";
import Dropdown from "../../../../components/dropdowns/Dropdown";

const PermissionCard = (props) => {
  const [role, setRole] = useState();
  const [options, setOptions] = useState([
    { name: "Co_Host", id: 1 },
    { name: "Guest", id: 2 },
  ]);
  console.log("role??????", role);
  return (
    <Dropdown
      style={{ zIndex: props.length - props.i }}
      // placeholder={}
      object={options}
      onChange={(e) => {
        setRole(e);
        props?.onChangestate(e);
      }}
      selectedValue={props?.role}
      selectedClass={styles.selectedClass}
    />
  );
};

export default PermissionCard;
